<table mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8"
    [hidden]="!dataSource?.data?.length">
    <ng-container matColumnDef="{{column}}" *ngFor="let column of objectKeys(columnHeader);let i= index;">
        <th mat-header-cell *matHeaderCellDef>
            <span [ngClass]="{'header-pl': column==='sourceTimestamp'}"></span>{{columnHeader[column]}}
        </th>
        <td mat-cell *matCellDef="let element;index as i;">
            <div class="align-items-center d-flex td-height">
                <span *ngIf="column!=='action'" class="table-use-red-fon arrow-image-before ">
                    <span *ngIf="column==='sourceTimestamp'">
                        <span *ngIf="element == expandedElement"><img class=" mx-100 default-img list-img-inn arrow-pl"
                                alt="collapse" src="../../assets/images/down-arrow.svg" title="collapse" /></span>
                        <span *ngIf="element != expandedElement"><img class=" mx-100 default-img list-img-inn arrow-pl"
                                alt="expand" src="../../assets/images/up-arrow.svg" title="expand" /></span>
                        <span class="time-pl">{{element[column] | date : 'shortTime'}}</span>
                    </span>
                    <span *ngIf="column!=='sourceTimestamp'">
                        <span *ngIf="column==='Respiratory Rate'">
                            <img class=" mx-100 default-img list-img-inn" alt="Flag" *ngIf="element['attrValid']"
                                src="../../assets/images/table-flag-dover.svg" title="Flag" />
                        </span>
                        <span [ngClass]="getClassOf(element,column)">{{element[column]}}</span>
                    </span>
                </span>
                <span *ngIf="column==='action'">
                    <img class=" mx-100 default-img list-img-inn z-index9999 position-relative mr-2" alt="addNote"
                        src="../../assets/images/addNote.svg" title="Add Note"
                        (click)="clickActions('note',element);$event.stopPropagation();" />
                    <img class="mx-100 default-img list-img-inn z-index9999 position-relative" alt="mapDevice"
                        *ngIf="element['hover']" src="../../assets/images/dover-map-device.svg" title="Map Device"
                        (click)="clickActions('map',element);$event.stopPropagation();" />
                </span>
            </div>
        </td>
    </ng-container>

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="objectKeys(columnHeader).length">
            <div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'"
                [ngClass]="{'expand-acc-table': element == expandedElement}">
                <app-dover-common-table [tableData]="element['previousData']" [columnHeader]="subTableColumnHeader"
                    [pageType]="'dover-accordion'">
                </app-dover-common-table>
            </div>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="objectKeys(columnHeader)"></tr>
    <tr mat-row *matRowDef="let element; columns: objectKeys(columnHeader);" class="example-element-row "
        [class.example-expanded-row]="expandedElement === element" [ngClass]="{'dover-tr-hover': element['hover']}"
        (click)="expandedElement = expandedElement === element ? null : element" (mouseenter)="element['hover']=true;"
        (mouseleave)="element['hover']=false;">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
</table>
<div [hidden]="dataSource?.data?.length" class="no-records">
    <div class="d-flex justify-content-center align-items-center vh-75">
        <div class="text-center image-style">
            <img src="../../../assets/images/nodata.svg" class="w-10" alt="no-data">
        </div>
    </div>
</div>